// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__1a3vs","messageCol":"Table_messageCol__36W7D","tableLoading":"Table_tableLoading__30rOE"};